import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FrontSettingsService } from '../../services/front-settings.service';
import { FRONTSETTINGS } from '../../interfaces/front-settings.interface';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {

  readonly currentYear: number = new Date().getFullYear();

  frontSettings: FRONTSETTINGS = {}

  classStyle: any = {}

  constructor(private router: Router, private route: ActivatedRoute, private _frontSettingsService: FrontSettingsService) {
    _frontSettingsService.frontSettings$.subscribe(frontSettings => {
      frontSettings.ASSOCIATED_BRAND_LOGOS?.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
      this.frontSettings = frontSettings;

    });
  }


  convertStylesToJson(styles: string, name: string) {
    try {
      const stylesJson = JSON.parse(styles);

      return stylesJson[name] || null;
    } catch (error) {
      return null;
    }
  }


}
